// extracted by mini-css-extract-plugin
export default {"specific-font":"about_specific-font__rNr+z"};